var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpacingAndWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3 8C3 8.41421 3.33579 8.75 3.75 8.75C4.16421 8.75 4.5 8.41421 4.5 8H3ZM7 4.5C7.41421 4.5 7.75 4.16421 7.75 3.75C7.75 3.33579 7.41421 3 7 3V4.5ZM17 13C17 12.5858 16.6642 12.25 16.25 12.25C15.8358 12.25 15.5 12.5858 15.5 13H17ZM12 15.5C11.5858 15.5 11.25 15.8358 11.25 16.25C11.25 16.6642 11.5858 17 12 17V15.5ZM4.5 8V4.75H3V8H4.5ZM4.75 4.5H7V3H4.75V4.5ZM15.5 13V15.25H17V13H15.5ZM15.25 15.5H12V17H15.25V15.5ZM15.5 15.25C15.5 15.3881 15.3881 15.5 15.25 15.5V17C16.2165 17 17 16.2165 17 15.25H15.5ZM4.5 4.75C4.5 4.61193 4.61193 4.5 4.75 4.5V3C3.7835 3 3 3.7835 3 4.75H4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99999 4C8.99999 3.44772 9.4477 3 9.99999 3H16C16.5523 3 17 3.44772 17 4V10C17 10.5523 16.5523 11 16 11C15.4477 11 15 10.5523 15 10V6.41421L10 11.4142V16C10 16.5523 9.55228 17 9 17H4C3.44772 17 3 16.5523 3 16V11C3 10.4477 3.44772 10 4 10H8.58577L13.5858 5H9.99999C9.4477 5 8.99999 4.55228 8.99999 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpacingAndWidth);
export default __webpack_public_path__ + "static/media/icon-spacing-and-width.2ede742c5eef2ca5e390858681ec0d62.svg";
export { ForwardRef as ReactComponent };